import { render, staticRenderFns } from "./markup.vue?vue&type=template&id=357d976c&lang=pug"
import script from "./markup.vue?vue&type=script&lang=js"
export * from "./markup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports